// extracted by mini-css-extract-plugin
module.exports = {"spotThumbnail":"SpotThumbnail_spotThumbnail__8Ly2w"};